import AddRecipePage from "./containers/AddRecipePage/AddRecipePage";
import EditRecipePage from "./containers/EditRecipePage/EditRecipePage";
import HomePage from "./containers/HomePage/HomePage";
import InfoPage from "./containers/InfoPage/InfoPage";
import ExplorePage from "./containers/ExplorePage/ExplorePage";
import ShowRecipePage from "./containers/ShowRecipePage/ShowRecipePage";
import SettingsPage from "./containers/SettingsPage/SettingsPage";
import UserRecipesPage from "./containers/UserRecipesPage/UserRecipesPage";

/**
 * Implement routing schema to the application.
 * @property {boolean} index - Set true for the index route.
 * @property {boolean} isNavMenuHidden - If set as true will hide NavMenu for this route. Default value = false.
 * @property {element} element - Parent component which will be generated for specific route.
 */

const AppRoutes = [
    {
        index: true,
        element: <HomePage />,
    },
    {
        path: "/recipe/:id",
        element: <ShowRecipePage />,
    },
    {
        path: "/recipe/edit/:id",
        element: <EditRecipePage />,
    },
    {
        path: "/user/:username",
        element: <UserRecipesPage />,
    },
    {
        path: "/explore",
        element: <ExplorePage />,
    },
    {
        path: "/info",
        element: <InfoPage />,
    },
    {
        path: "settings",
        element: <SettingsPage />,
    },
    {
        path: "/add",
        element: <AddRecipePage />,
    },
];

export default AppRoutes;
